export default {
  centimeter: {
    value: ' cm',
  },
  millimeter: {
    value: ' mm',
  },
  meter: {
    value: ' m',
  },
  kilogram: {
    value: ' kg',
  },
  gram: {
    value: ' gr',
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-quote/features/freight-quote/enums/EnumDimensions.js